var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoutTrip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.74995,
    cy: 2.74995,
    r: 1.74995,
    fill: "#18181B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0355 11.0698V15.0001M11.0703 13.0349H15.0006",
    stroke: "#18181B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.61328 2.61505H10.8528C12.2503 2.61505 13.3831 3.74789 13.3831 5.14533V5.14533C13.3831 6.54276 12.2503 7.6756 10.8528 7.6756H5.28814C3.81086 7.6756 2.61328 8.87318 2.61328 10.3505V10.3505C2.61328 11.8278 3.81086 13.0253 5.28814 13.0253H9.73503",
    stroke: "#18181B",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutTrip);
export default __webpack_public_path__ + "static/media/rout-trip.bfce29bc653c7f16c977368c96f403ad.svg";
export { ForwardRef as ReactComponent };